<template>
	<section>
		<h1>Ihre Beschwerde wurde eingereicht</h1>

		<p>
			Vielen Dank für Ihre Beschwerde. Wir haben den Fall zur Bearbeitung aufgenommen. In einem ersten Schritt überprüfen wir unsere Zuständigkeit und
			melden uns bei Rückfragen.
		</p>
		<p>
			Erst nach Abschluss des Bearbeitungs- bzw. Entscheidungsverfahrens wird Ihre Beschwerde veröffentlicht und
			<RouterLink :to="'/beschwerden'" :title="'Alle Beschwerden'" class="link"> hier </RouterLink> abrufbar sein.
		</p>
	</section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'BeschwerdeNeuDoneView',
	data() {
		return {};
	},
	components: {},
	setup() {},
	computed: {},
	methods: {},
});
</script>
